import React from 'react';
const CloseSVG = ({ color = 'red', className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M9 18.5C13.9558 18.5 18 14.4559 18 9.5C18 4.54416 13.9557 0.5 9 0.5C4.04428 0.5 0 4.54428 0 9.5C0 14.4557 4.04428 18.5 9 18.5ZM9 1.66883C13.3247 1.66883 16.8312 5.17532 16.8312 9.5C16.8312 13.8247 13.3247 17.3312 9 17.3312C4.67532 17.3312 1.16883 13.8247 1.16883 9.5C1.16883 5.17532 4.67532 1.66883 9 1.66883Z"
        fill={color}
      />
      <path
        d="M5.77405 12.7261C5.89097 12.843 6.0312 12.8898 6.19475 12.8898C6.35846 12.8898 6.49869 12.843 6.61544 12.7261L9.00007 10.3183L11.4079 12.7261C11.5248 12.843 11.665 12.8898 11.8286 12.8898C11.9923 12.8898 12.1325 12.843 12.2492 12.7261C12.4831 12.4923 12.4831 12.1184 12.2492 11.9079L9.81833 9.50006L12.2261 7.09227C12.46 6.85844 12.46 6.48452 12.2261 6.27401C11.9923 6.04017 11.6184 6.04017 11.4079 6.27401L9.00007 8.6818L6.59227 6.27401C6.35844 6.04017 5.98452 6.04017 5.77401 6.27401C5.54017 6.50784 5.54017 6.88176 5.77401 7.09227L8.1818 9.50006L5.77401 11.9079C5.54034 12.1182 5.54034 12.4923 5.77401 12.7261H5.77405Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseSVG;
